module.exports = __webpack_public_path__ + "static/img/electricidad.eeafe06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/electricidad.jpg
// module id = t+mh
// module chunks = 1